import * as tslib_1 from "tslib";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { normalizeUrl, mergeStyles, validate, Context, } from 'wix-rich-content-common';
import invoke from 'lodash/invoke';
import isEqual from 'lodash/isEqual';
import schema from './data-schema.json';
import styles from './link-viewer.scss';
var LinkViewer = /** @class */ (function (_super) {
    tslib_1.__extends(LinkViewer, _super);
    function LinkViewer(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (event) {
            invoke(_this, 'props.settings.onClick', event, _this.getHref());
        };
        validate(props.componentData, schema);
        _this.state = { styles: styles };
        return _this;
    }
    LinkViewer.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (!isEqual(nextProps.componentData, this.props.componentData)) {
            validate(nextProps.componentData, schema);
        }
    };
    LinkViewer.prototype.componentDidMount = function () {
        var theme = this.context && this.context.theme;
        this.setState({ styles: mergeStyles({ styles: styles, theme: theme }) });
    };
    LinkViewer.prototype.getHref = function () {
        return normalizeUrl(this.props.componentData.url);
    };
    LinkViewer.prototype.render = function () {
        var children = this.props.children;
        var anchorProps = {
            href: this.getHref(),
            target: '_blank',
            rel: 'nofollow noopener',
            className: this.state.styles.link,
            onClick: this.handleClick,
        };
        return React.createElement("a", tslib_1.__assign({}, anchorProps), children);
    };
    LinkViewer.propTypes = {
        componentData: PropTypes.object.isRequired,
        theme: PropTypes.object,
        children: PropTypes.node,
        anchorTarget: PropTypes.string,
        relValue: PropTypes.string,
        settings: PropTypes.object,
    };
    return LinkViewer;
}(Component));
LinkViewer.contextType = Context.type;
export default LinkViewer;
//# sourceMappingURL=LinkViewer.js.map